import { signedDelete } from "./signedRequest";

export async function deleteCurrentProfile() {
  const response = await signedDelete("/api/v1/profiles/me");
  return response?.data || { deleted: true };
}
